import { canUseDOM } from '../../../../utils';
export var toggleLeftPanelOverflow = function toggleLeftPanelOverflow(ref) {
  var leftPanel = canUseDOM ? document.querySelector('.m114-im__left-bar') : null;
  var bodyElement = canUseDOM ? document.querySelector('body') : null;
  if (leftPanel && bodyElement) {
    if (ref.current.classList.contains('filter__wrapper--open')) {
      leftPanel.style.overflow = 'hidden';
      leftPanel.style.zIndex = '6';
      bodyElement.classList.add('prevent-scroll');
    } else {
      leftPanel.style.overflow = 'scroll';
      leftPanel.style.overflowX = 'hidden';
      leftPanel.style.zIndex = '1';
      bodyElement.classList.remove('prevent-scroll');
    }
  }
};
export var removeBodyOverflow = function removeBodyOverflow() {
  var bodyElement = canUseDOM ? document.querySelector('body') : null;
  if (bodyElement) {
    bodyElement.classList.remove('prevent-scroll');
  }
};